import { State } from '../../../../../interfaces/merchants/products/purchases/inputs';

export const getInputs = (state: State) => state;
